// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"fe359983","325":"cd583631","383":"ffa3a072","509":"77b6a33f","541":"7e933550"}[chunkId] + ".chunk.js";
};